import React from 'react';
import { Card, Col } from 'react-bootstrap';

const Product = ({ am }) => {
    const { name, location, price, img } = am;
    return (
        <Col>
            <Card className='amer-bari-shadow'>
                <Card.Img variant="top" src={img} />
                <Card.Body>
                    <Card.Title>{name}</Card.Title>
                    <h4>Location: {location}</h4>
                    <Card.Text>
                        <ul>
                            <li>ফরমালিনমুক্ত</li>
                            <li>সম্পূর্ণ অরগানিক</li>
                            <li>বাগানের তরতাজা</li>
                        </ul>
                    </Card.Text>
                    {/* <Card.Title>{price} টাকা /KG</Card.Title> */}
                </Card.Body>
            </Card>
        </Col>
    );
};

export default Product;